var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageDefaultLayout',{attrs:{"title":"お知らせ"}},[_c('div',{staticClass:"w-full right lg:bg-gray-50 mx-auto"},[_c('Notifications',{attrs:{"notifications":_vm.notifications}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }